import React from "react";
import { Modules } from "../../../constants/Module";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import CreatorDetails from "./creatorDetails";
import { ChangeRequestStatus } from "../../../constants/Status";
import { withTranslation } from "react-i18next";

const ChangeRequest = ({ item, t }) => {

    return (
        <React.Fragment>
            <div className="mx-2">
                <div>
                    <strong> {ucFirst(Modules.CHANGE_REQUEST)} ({item.payload?.uniqueChangeRequestId}) </strong> {item.event === Action.CREATE ? t('was created') : t('was updated')}
                    <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                </div>
                {item.event === Action.UPDATE &&
                    <div>
                        {item.payload?.description &&
                            item.payload?.description?.old &&
                            item.payload?.description?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Description') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.description?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.description?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.reason &&
                            item?.payload?.reason?.old &&
                            item?.payload?.reason?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Reason') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.reason?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.reason?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.impact &&
                            item?.payload?.impact?.old &&
                            item?.payload?.impact?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Impact') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.impact?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.impact?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.negativeImpact &&
                            item?.payload?.negativeImpact?.old &&
                            item?.payload?.negativeImpact?.new && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        <strong> {t('Negative Impact') + ':'}</strong>
                                        <div className="d-flex align-items-center mx-2">
                                            <span>{item?.payload?.negativeImpact?.old}</span>
                                        </div>
                                        <span className="middleArrow mx-2">
                                            <ArrowRightAltOutlinedIcon />
                                        </span>
                                        <div className="d-flex align-items-center">
                                            <span className="mx-2">
                                                {item?.payload?.negativeImpact?.new}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        {item?.payload?.status &&
                            typeof item?.payload?.status === 'object' && (
                                <div className="mx-2">
                                    <div className="d-flex align-items-center change_status">
                                        {item?.payload?.status?.new === ChangeRequestStatus.REJECTED &&
                                            <div className="d-flex align-items-center change_status">
                                                <span>{t('Change request is rejected by')} <strong>{item?.creator?.projectUsers[0]?.role?.name} [{item?.creator?.name} | {item?.creator?.uniqueUserId}]</strong>
                                                </span>
                                            </div>
                                        }
                                        {item?.payload?.status?.new === ChangeRequestStatus.APPROVED &&
                                            <div className="d-flex align-items-center change_status">
                                                <span>{t('Change request is approved by')} <strong>{item?.creator?.projectUsers[0]?.role?.name} [{item?.creator?.name} | {item?.creator?.uniqueUserId}]</strong>
                                                </span>
                                            </div>
                                        }
                                        {item?.payload?.status?.new === ChangeRequestStatus.IN_APPROVAL &&
                                            <div className="d-flex align-items-center change_status">
                                                <span>{t('Change request')} {item?.payload?.status?.old === ChangeRequestStatus.DRAFT ? t('is sent for approval by') : t('is re-submitted by')} <strong>{item?.creator?.projectUsers[0]?.role?.name} [{item?.creator?.name} | {item?.creator?.uniqueUserId}]</strong>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            )}
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(ChangeRequest);
